import { notEmpty } from '@mews-commander/utils';

export const isOtherService = (useServiceId: $TSFixMe, timelineServiceId: $TSFixMe) =>
    useServiceId && useServiceId !== timelineServiceId;
export const isUseCluster = ({ resourceUseIds }: $TSFixMe) => notEmpty(resourceUseIds);
